import { IOptionItem } from 'interfaces'

export const OTHER = 'other'

export const STATUS_BODY_OPTIONS: Array<IOptionItem> = [
  {
    label: 'good',
    value: 'good'
  },
  {
    label: 'medium',
    value: 'medium'
  },
  {
    label: 'not-good',
    value: 'notGood'
  },
  {
    label: OTHER,
    value: OTHER
  }
]

export const MOCUSAL_SKIN_OPTIONS: Array<IOptionItem> = [
  {
    label: 'ruddy',
    value: 'ruddy'
  },
  {
    label: OTHER,
    value: OTHER
  }
]

export const PERIPHERAL_NODES_OPTIONS: Array<IOptionItem> = [
  {
    label: 'do-not-touch',
    value: 'do-not-touch'
  },
  {
    label: OTHER,
    value: OTHER
  }
]

export const HEART_OPTIONS: Array<IOptionItem> = [
  {
    label: 'even',
    value: 'even'
  },
  {
    label: 't1',
    value: 't1'
  },
  {
    label: 't2-clear',
    value: 't2'
  },
  {
    label: OTHER,
    value: OTHER
  }
]

export const LUNG_OPTIONS: Array<IOptionItem> = [
  {
    label: 'transparent',
    value: 'transparent'
  },
  {
    label: 'no-rales',
    value: 'no-rales'
  },
  {
    label: OTHER,
    value: OTHER
  }
]

export const DIGESTION_OPTIONS: Array<IOptionItem> = [
  {
    label: 'transparent',
    value: 'transparent'
  },
  {
    label: 'soft-belly',
    value: 'soft-belly'
  },
  {
    label: 'no-focal-pain-points',
    value: 'no-focal-pain-points'
  },
  {
    label: OTHER,
    value: OTHER
  }
]

export const URINARY_KIDNEY_OPTIONS: Array<IOptionItem> = [
  {
    label: 'negative',
    value: 'negative'
  },
  {
    label: 'kidney-bobbing',
    value: 'kidney-bobbing'
  },
  {
    label: OTHER,
    value: OTHER
  }
]

export const C_NOTE_USAGE_OPTIONS = [
  {
    label: 'before-eating',
    value: 'before-eating'
  },
  {
    label: 'after-eating',
    value: 'after-eating'
  }
]

export const C_NOTE_USAGE_NIGHT_OPTIONS = [
  {
    label: 'before-eating',
    value: 'before-eating'
  },
  {
    label: 'after-eating',
    value: 'after-eating'
  },
  {
    label: 'before-to-bed',
    value: 'before-to-bed'
  }
]
